import { z } from "zod";

export enum ESitePhotoOcrResultStatus {
  NOT_DONE = "NOT_DONE",
  PENDING = "PENDING",
  PROCESSING = "PROCESSING",
  OK = "OK",
  KO = "KO",
  FAILED = "FAILED",
}

export const sitePhotoOcrResultStatusSchema = z.nativeEnum(ESitePhotoOcrResultStatus).nullable();
export type OcrResultStatus = z.infer<typeof sitePhotoOcrResultStatusSchema>;

export const applianceTypeAndLocalisationSchema = z.object({
  type: z.string(),
  localisation: z.string().nullable(),
});

export const geolocationSchema = z
  .object({
    latitude: z.number().nullable(),
    longitude: z.number().nullable(),
    simulated: z.boolean(),
  })
  .refine((data) => (data.latitude === null) === (data.longitude === null), {
    message: "latitude et longitude doivent être toutes les deux non-nulles ou toutes les deux nulles",
    path: ["latitude", "longitude"],
  });

export const sitePhotoDtoSchema = z.object({
  id: z.string(),
  siteId: z.number(),
  number: z.number(),
  photoTypeRefId: z.number(),
  fileName: z.string(),
  personId: z.number(),
  personFirstName: z.string().nullable(),
  personLastName: z.string().nullable(),
  creationDateTime: z.coerce.date(),
  uploadDateTime: z.coerce.date(),
  hash: z.string(),
  hwModulatorId: z.number().nullable(),
  hwMomboxId: z.number().nullable(),
  csModulatorId: z.number().nullable(),
  deviceSerial: z.string().nullable(),
  url: z.string(),
  source: z.string(),
  geolocation: geolocationSchema.nullable(),
  applianceTypeAndLocalisation: applianceTypeAndLocalisationSchema,
});

export type TSitePhotoDto = z.infer<typeof sitePhotoDtoSchema>;
